import React from 'react';
import {View} from 'react-native';

import Button from '/component/base/Button';
import {SearchAndFilter} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

import {Loading} from '../SearchResultItem/Loading';

import {styles} from './Footer.style';

interface FooterProps {
  isLoading: boolean;
  hasSearchResults: boolean;
  isEndReached: boolean;
  fetchMore: (params?: any) => void;
  recordsParams: Record<string, any>;
}

export const Footer: React.FC<FooterProps> = ({
  isLoading = false,
  hasSearchResults = false,
  isEndReached = true,
  fetchMore = () => {},
  recordsParams = {},
}) => {
  const {ts} = useTranslation('screen.search');

  if (isEndReached || !hasSearchResults) {
    return null;
  }
  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <Loading style={styles.loading} />
        <Loading style={styles.loading} />
      </View>
    );
  }

  return (
    <View style={styles.buttonContainer}>
      <Button
        type="secondary"
        style={{base: styles.button}}
        onPress={generateCallback({func: fetchMore, params: {recordsParams}})}
        {...testProperties(SearchAndFilter.searchResultsShowMore)}>
        {ts('showMore', 'Show more')}
      </Button>
    </View>
  );
};
